var widget_default = {
  "card": "Bny-R",
  "link": "IGBXQ",
  "container": "q-0Ox",
  "image": "FyCcT",
  "right": "S8brJ",
  "cardLayout": "A79tT",
  "content": "hwWCf",
  "title": "tw0JO",
  "subtitle": "fglWV",
  "button": "bBS-J",
  "button_disabled": "ET-o-",
  "buttonText": "-giLv",
  "slimLayout": "AV8DW",
  "contentText": "CW40h"
};
export {
  widget_default as default
};
//# sourceMappingURL=widget-scss.js.map
